/* ================================================================
   OUTFIT BUENO — scripts propios (vanilla, sin librerías)
   ================================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Reveals al hacer scroll --------------------------------- */
  function initReveals() {
    var items = document.querySelectorAll('.ob-reveal');
    if (!items.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('ob-visible'); });
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-ob-delay') || '0', 10);
        setTimeout(function () { el.classList.add('ob-visible'); }, delay);
        obs.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    items.forEach(function (el) { obs.observe(el); });
  }

  /* --- Marquesina infinita ------------------------------------- */
  function initMarquesinas() {
    var pistas = document.querySelectorAll('.ob-marq__pista');
    if (!pistas.length) return;

    pistas.forEach(function (pista) {
      var grupo = pista.querySelector('.ob-marq__grupo');
      if (!grupo || pista.getAttribute('data-ob-listo')) return;
      pista.setAttribute('data-ob-listo', '1');

      // duplicamos el grupo para que el bucle sea continuo
      if (pista.children.length < 2) {
        pista.appendChild(grupo.cloneNode(true));
      }

      if (reduce) return;

      var segundos = parseFloat(pista.getAttribute('data-ob-velocidad') || '32');
      var estilo = document.createElement('style');
      var id = 'obmarq' + Math.random().toString(36).slice(2, 8);
      pista.setAttribute('data-ob-id', id);
      estilo.textContent =
        '@keyframes ' + id + '{from{transform:translateX(0)}to{transform:translateX(-50%)}}' +
        '[data-ob-id="' + id + '"]{animation:' + id + ' ' + segundos + 's linear infinite}' +
        '.ob-marq:hover [data-ob-id="' + id + '"]{animation-play-state:paused}';
      document.head.appendChild(estilo);
    });
  }

  /* --- Parallax suave del hero --------------------------------- */
  function initParallax() {
    var medios = document.querySelectorAll('[data-ob-parallax]');
    if (!medios.length || reduce) return;

    var ticking = false;
    function pintar() {
      medios.forEach(function (m) {
        var fuerza = parseFloat(m.getAttribute('data-ob-parallax')) || 0;
        if (!fuerza) return;
        var caja = m.getBoundingClientRect();
        if (caja.bottom < 0 || caja.top > window.innerHeight) return;
        m.style.transform = 'translate3d(0,' + (window.scrollY * fuerza * 0.1) + 'px,0) scale(1.12)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(pintar);
    }, { passive: true });
    pintar();
  }

  /* --- Galería de la página de producto ------------------------ */
  function initGaleria() {
    var galeria = document.querySelector('[data-ob-galeria]');
    if (!galeria) return;
    var principal = galeria.querySelector('[data-ob-principal]');
    var minis = galeria.querySelectorAll('[data-ob-mini]');
    if (!principal || !minis.length) return;

    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-ob-src');
        if (!src) return;
        principal.src = src;
        minis.forEach(function (m) { m.classList.remove('ob-activa'); });
        mini.classList.add('ob-activa');
      });
    });
  }

  /* --- Selector de variantes ----------------------------------- */
  function initVariantes() {
    var raiz = document.querySelector('[data-ob-producto]');
    if (!raiz) return;

    var datos = raiz.querySelector('[data-ob-variantes]');
    if (!datos) return;

    var variantes;
    try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
    if (!variantes || !variantes.length) return;

    var inputId = raiz.querySelector('[data-ob-id-variante]');
    var boton = raiz.querySelector('[data-ob-add]');
    var precio = raiz.querySelector('[data-ob-precio]');
    var precioAntes = raiz.querySelector('[data-ob-precio-antes]');
    var urgencia = raiz.querySelector('[data-ob-urgencia]');
    var botones = raiz.querySelectorAll('[data-ob-opcion]');
    if (!botones.length) return;

    var textoNormal = boton ? boton.getAttribute('data-ob-texto') : '';
    var textoAgotado = boton ? boton.getAttribute('data-ob-agotado') : '';

    function aplicar(variante) {
      if (!variante) return;
      if (inputId) inputId.value = variante.id;
      if (precio) precio.textContent = variante.precio;
      if (precioAntes) {
        if (variante.antes) {
          precioAntes.textContent = variante.antes;
          precioAntes.style.display = '';
        } else {
          precioAntes.style.display = 'none';
        }
      }
      if (boton) {
        boton.disabled = !variante.disponible;
        boton.textContent = variante.disponible ? textoNormal : textoAgotado;
      }

      // el aviso de "solo quedan N" tiene que seguir a la talla elegida
      if (urgencia && urgencia.getAttribute('data-ob-urg-modo') === 'existencias') {
        var texto = urgencia.querySelector('[data-ob-urg-texto]');
        var umbral = parseInt(urgencia.getAttribute('data-ob-urg-umbral') || '10', 10);
        var plantilla = urgencia.getAttribute('data-ob-urg-plantilla') || '';
        var quedan = variante.stock;
        if (typeof quedan === 'number' && quedan > 0 && quedan <= umbral) {
          if (texto) texto.textContent = plantilla.replace('[N]', quedan);
          urgencia.style.display = '';
        } else {
          urgencia.style.display = 'none';
        }
      }
    }

    botones.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.hasAttribute('disabled')) return;
        var grupo = btn.getAttribute('data-ob-grupo');
        raiz.querySelectorAll('[data-ob-grupo="' + grupo + '"]').forEach(function (b) {
          b.classList.remove('ob-activa');
        });
        btn.classList.add('ob-activa');

        var elegidas = [];
        raiz.querySelectorAll('[data-ob-opcion].ob-activa').forEach(function (b) {
          elegidas[parseInt(b.getAttribute('data-ob-grupo'), 10)] = b.getAttribute('data-ob-valor');
        });

        var encontrada = variantes.filter(function (v) {
          return v.opciones.every(function (val, i) {
            return elegidas[i] === undefined || elegidas[i] === val;
          });
        })[0];
        aplicar(encontrada);
      });
    });
  }

  function arrancar() {
    initReveals();
    initMarquesinas();
    initParallax();
    initGaleria();
    initVariantes();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();

/* ================================================================
   OUTFIT BUENO — cabecera (menú móvil + fondo al bajar)
   ================================================================ */
(function () {
  'use strict';

  function initHeader() {
    var header = document.querySelector('[data-ob-header]');
    if (!header) return;

    var burger = header.querySelector('[data-ob-burger]');
    var nav = header.querySelector('[data-ob-nav]');

    if (burger && nav) {
      burger.addEventListener('click', function () {
        var abierto = nav.classList.toggle('ob-abierto');
        burger.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
      nav.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () {
          nav.classList.remove('ob-abierto');
          burger.setAttribute('aria-expanded', 'false');
        });
      });
      document.addEventListener('click', function (e) {
        if (!header.contains(e.target)) {
          nav.classList.remove('ob-abierto');
          burger.setAttribute('aria-expanded', 'false');
        }
      });
    }

    if (!header.classList.contains('ob-header--flotante')) return;

    var ticking = false;
    function mirar() {
      header.classList.toggle('ob-header--solido', window.scrollY > 40);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(mirar);
    }, { passive: true });
    mirar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeader);
  } else {
    initHeader();
  }
})();

/* ================================================================
   Orden de las categorías y cantidades del carrito
   ================================================================ */
(function () {
  function initOrden() {
    var sel = document.querySelector('[data-ob-orden]');
    if (!sel || sel.getAttribute('data-ob-listo')) return;
    sel.setAttribute('data-ob-listo', '1');
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  function initCarrito() {
    var lineas = document.querySelectorAll('[data-ob-linea]');
    if (!lineas.length) return;

    lineas.forEach(function (linea) {
      if (linea.getAttribute('data-ob-listo')) return;
      linea.setAttribute('data-ob-listo', '1');
      var input = linea.querySelector('[data-ob-input]');
      var menos = linea.querySelector('[data-ob-menos]');
      var mas = linea.querySelector('[data-ob-mas]');
      if (!input) return;

      function enviar() {
        var form = input.closest('form');
        if (!form) return;
        var boton = form.querySelector('[name="update"]');
        if (boton) boton.click();
        else form.submit();
      }

      if (menos) menos.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 0;
        input.value = Math.max(0, v - 1);
        enviar();
      });
      if (mas) mas.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 0;
        input.value = v + 1;
        enviar();
      });
      input.addEventListener('change', enviar);
    });
  }

  function init() { initOrden(); initCarrito(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ================================================================
   Menús desplegables de la cabecera
   ================================================================ */
(function () {
  function init() {
    var grupos = document.querySelectorAll('[data-ob-grupo]');
    if (!grupos.length) return;
    var escritorio = window.matchMedia('(min-width: 1101px)');

    function cerrarTodos(salvo) {
      grupos.forEach(function (g) {
        if (g === salvo) return;
        g.removeAttribute('data-abierto');
        var b = g.querySelector('[data-ob-abrir]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }

    grupos.forEach(function (grupo) {
      var boton = grupo.querySelector('[data-ob-abrir]');
      if (!boton || grupo.getAttribute('data-ob-listo')) return;
      grupo.setAttribute('data-ob-listo', '1');

      boton.addEventListener('click', function (e) {
        e.stopPropagation();
        var abierto = grupo.hasAttribute('data-abierto');
        cerrarTodos(grupo);
        if (abierto) {
          grupo.removeAttribute('data-abierto');
          boton.setAttribute('aria-expanded', 'false');
        } else {
          grupo.setAttribute('data-abierto', '');
          boton.setAttribute('aria-expanded', 'true');
        }
      });

      grupo.addEventListener('mouseenter', function () {
        if (!escritorio.matches) return;
        cerrarTodos(grupo);
        grupo.setAttribute('data-abierto', '');
        boton.setAttribute('aria-expanded', 'true');
      });
      grupo.addEventListener('mouseleave', function () {
        if (!escritorio.matches) return;
        grupo.removeAttribute('data-abierto');
        boton.setAttribute('aria-expanded', 'false');
      });
    });

    document.addEventListener('click', function () { cerrarTodos(null); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') cerrarTodos(null);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ================================================================
   Desplegar la lista de marcas
   ================================================================ */
(function () {
  function init() {
    var cajas = document.querySelectorAll('[data-ob-marcas]');
    cajas.forEach(function (caja) {
      var boton = caja.querySelector('[data-ob-marcas-mas]');
      if (!boton || caja.getAttribute('data-ob-listo')) return;
      caja.setAttribute('data-ob-listo', '1');
      var texto = boton.querySelector('[data-ob-texto-mas]');
      var original = texto ? texto.textContent : '';
      boton.addEventListener('click', function () {
        var abierta = caja.classList.toggle('ob-marcas--abierta');
        if (texto) texto.textContent = abierta ? 'Ver menos' : original;
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ================================================================
   Ventana de bienvenida (captación de correos) y copiar el cupón
   ================================================================ */
(function () {
  function recordar(clave, dias) {
    try {
      var hasta = Date.now() + (dias * 24 * 60 * 60 * 1000);
      localStorage.setItem(clave, String(hasta));
    } catch (e) { /* navegación privada: no pasa nada */ }
  }

  function yaVista(clave) {
    try {
      var v = localStorage.getItem(clave);
      if (!v) return false;
      if (Date.now() > parseInt(v, 10)) { localStorage.removeItem(clave); return false; }
      return true;
    } catch (e) { return false; }
  }

  function init() {
    var pop = document.querySelector('[data-ob-pop]');
    if (!pop || pop.getAttribute('data-ob-listo')) return;
    pop.setAttribute('data-ob-listo', '1');

    var clave = pop.getAttribute('data-ob-clave') || 'obpop';
    var dias = parseInt(pop.getAttribute('data-ob-memoria') || '30', 10);
    var retraso = parseInt(pop.getAttribute('data-ob-retraso') || '5', 10) * 1000;
    var recienSuscrito = pop.hasAttribute('data-ob-abrir-ya');

    // Shopify enseña su aviso de cookies encima de todo. Si abrimos la
    // ventana antes de que el cliente lo conteste, se la tapa (sobre todo en
    // el móvil). Así que esperamos a que desaparezca.
    function avisoCookiesVisible() {
      var b = document.querySelector('#shopify-pc__banner, .shopify-pc__banner');
      if (!b) return false;
      var cs = getComputedStyle(b);
      if (cs.display === 'none' || cs.visibility === 'hidden') return false;
      return b.getBoundingClientRect().height > 0;
    }

    function abrir() {
      if (avisoCookiesVisible()) { esperarCookies(); return; }
      pop.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }

    function esperarCookies() {
      var intentos = 0;
      var reloj = setInterval(function () {
        intentos++;
        if (!avisoCookiesVisible()) {
          clearInterval(reloj);
          setTimeout(abrir, 600);
        } else if (intentos > 120) {
          clearInterval(reloj); // 2 minutos: se rinde y no molesta más
        }
      }, 1000);
    }

    function cerrar() {
      pop.hidden = true;
      document.documentElement.style.overflow = '';
      recordar(clave, dias);
    }

    pop.querySelectorAll('[data-ob-pop-cerrar]').forEach(function (b) {
      b.addEventListener('click', cerrar);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !pop.hidden) cerrar();
    });

    // copiar el código del cupón
    var copiar = pop.querySelector('[data-ob-copiar]');
    if (copiar) {
      copiar.addEventListener('click', function () {
        var codigo = (pop.querySelector('[data-ob-codigo]') || {}).textContent || '';
        var listo = copiar.getAttribute('data-ob-copiado') || '¡Copiado!';
        var original = copiar.textContent;
        function ok() {
          copiar.textContent = listo;
          setTimeout(function () { copiar.textContent = original; }, 2200);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(codigo.trim()).then(ok).catch(ok);
        } else {
          var t = document.createElement('textarea');
          t.value = codigo.trim();
          document.body.appendChild(t); t.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(t);
          ok();
        }
      });
    }

    // si acaba de suscribirse, se abre al momento para enseñarle el código
    if (recienSuscrito) {
      recordar(clave, dias);
      abrir();
      return;
    }

    if (yaVista(clave)) return;
    // en el editor de temas se enseña siempre, para poder trabajarla
    if (window.Shopify && window.Shopify.designMode) { abrir(); return; }
    setTimeout(abrir, retraso);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
